<template>
    <div class="a-iosPrompt" @click="toggle">
        <slot></slot>
        <transition name="fade-fast">
            <div v-if="show" class="a-iosPrompt__message" v-html="message"></div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        autoShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: false,
            message:
                "Zainstaluj aplikację na iOS. Stuknij w ikonkę <span style='padding: 0 5px'><img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAUCAYAAABWMrcvAAAABHNCSVQICAgIfAhkiAAAAUdJREFUOI29kbsuhFEUhb/9O5FoJOgFjbg0opHpFNpp0KiIat7BG0h4AVG4lBoRhVJEFHqlS3QSIi5zPXsp5p/xm4yYiFjJbvZZ3zlr74Na5B51/1zR3FZR148VuXurRQkZSeKp6CzsOmd3XczvOQ/vEcmzNpIs8FZ1FvcjS1Mw2BspzMD8TpXXstpDAJf3kdkRUZgJIGN5OpAfN85va0gZsHWe6FHRXaPrJUV3RY9yj58eSeHoqoJjIADR1wO5oQCAS1zcVnkqGsLq0RIRVg9EfgzAAGO4X+SG6ikMcXoD14/WTHZ4BUxulOQe5e7NasSrZXqeRp3YLCoofcHs87bG0IaRaaeHydftdaq/hpRWh5ABxysJreM0FNpCZowMdP8m3vf6Pyhg6YbaL6opZQzhpSS2L6vU//9n8KUsbO2krKjOU3YhPgB0G/ee+9G5TgAAAABJRU5ErkJggg==' />,</span> następnie <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEVoaHGkpKnOztGenqT6+vtubneKipH///+np6xra3Rzc3x4eIDf3+GDg4rZ2dtpaXLz8/TT09Wzs7iYmJ9/f4fMzM/l5eavr7TKys0N3sbbAAABX0lEQVRYw+2YyW7DMBBDqWqhZS3xmuT/v7SHNluTNLI1aIDCPNmA8GANBJkkKCRcPZs8aDcFa/0LWRsmp4dsHoL2jcVCWbW/A3UKq6S6W1AMWKk2XoN6i9WyHxdQrOAAPp5AXUCV2u4bpFAp9QXao1qRhMAHAYoEja0HWUMwQ0CZ4CABGghqCdBI0EmAHMEgAQoEWwlQS9BKgDxBLwHaEdxJgFACcvPsSkCvliRDmkkA1LDkpikFNRtoA70TlFRz0pEkj+dXNS0BOfPcmhm3ADT/ZvLmd4DEtoZ0Hm4z3w67SduB3ED/ByTxg0yGNEnERHyUmYi/szWlRkvM+omZUTF7LGLYE8FRKkKIhJqDVMzqhYKfN0JRVJMgo1Q4ro9++lQgVB7uc4HAXJWQfL6ULHMFyR+va5+8endt/lFErZy47u6qsagX78/r+Lis6w9jCrbgytzZkMZD3z1p/ar0CVS4HQG2U2V+AAAAAElFTkSuQmCC' /> 'Do ekranu początk.'"
        }
    },
    methods: {
        toggle() {
            this.show = !this.show
        },
        hide() {
            this.show = false
        }
    },
    mounted() {
        this.show = this.autoShow
    }
}
</script>